<template>
  <b-form-group
    :id="id + '-group'"
    :label="label"
    :label-for="id"
    :state="!errors.has(id)"
    :invalid-feedback="errors.first(id)"
    class="form-checkbox"
  >
    <input
      :id="id"
      ref="form-checkbox"
      v-model="checked"
      v-validate="{ rules: validationRules }"
      :name="id"
      :class="{ 'form-checkbox__checkbox': true, 'checked': checked }"
      :disabled="disabled"
      :data-testing="dataTesting"
      type="checkbox"
      data-vv-validate-on="change"
      @change="onChange()"
    >
    <label
      :for="id"
      :class="{ 'form-checkbox__label': true, 'form-checkbox__label--disabled': disabled }"
    >
      <!-- @slot for Label Text -->
      <slot />
    </label>
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue';

/**
 * Standard Form Checkbox Field
 */
export default {
  name: 'FormCheckbox',
  components: {
    BFormGroup
  },
  inject: {
    $validator: '$validator'
  },
  props: {
    /**
    * input id
    */
    id: {
      type: String,
      required: true
    },
    /**
    * label for the checkbox
    */
    label: {
      type: String,
      default: ''
    },
    /**
    * value to fill in data from the api
    */
    value: {
      type: Boolean,
      default: null
    },
    /**
    * required attribute
    */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * disabled attribute
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Variable for cypress testing
     */
    dataTesting: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      /**
       * @model
       */
      checked: false
    };
  },
  computed: {
    /**
     * Sets the validationRules, according to the type of the input field.
     */
    validationRules() {
      return {
        required: this.required
      };
    }
  },
  // detect changes in store step data
  watch: {
    value(newVal) {
      if(this.checked !== newVal) this.checked = newVal;
    }
  },
  mounted() {
    if (this.value) this.checked = this.value;
  },
  methods: {
    /**
    * update model
    * @event change
    */
    onChange() {
      this.$validator.validate(
        this.id
      );

      this.$emit('onchange', { key: this.id, val: this.checked });
    }
  },
};

</script>

<style lang="scss" scoped>
  @import './FormCheckbox';
</style>
